import useIsBuySupportedByAssetFn from './use-is-buy-supported-by-asset-fn.js';

function useIsBuySupportedByAsset(assetName: string) {
  const isBuySupportedByAsset = useIsBuySupportedByAssetFn();
  return isBuySupportedByAsset(assetName);
}

export default useIsBuySupportedByAsset;
